import { Component, OnInit } from '@angular/core';
import { SEOService } from 'src/app/shared/seo.service';

@Component({
  selector: 'app-documentation',
  templateUrl: './documentation.component.html',
  styleUrls: ['./documentation.component.css']
})
export class DocumentationComponent implements OnInit {

  constructor(public seoService:SEOService) { }

  ngOnInit(): void {

    this.setMeta();
  }


  setMeta() {
    var desc;
    var keys;
    var title

    keys = 'Pratiu nedir?, Hakkımızda';
    title = 'pratiu - Hakkımızda';
    desc = title;

    this.seoService.updateDescription(desc);
    this.seoService.updateKeywords(keys);
    this.seoService.updateTitle(title); 
  }

}
